import { useCurrentUserSecurityQuery } from '../access-control-hooks';

export function useCurrentUserIsChecklistEditor() {
    const query = useCurrentUserSecurityQuery();

    return {
        isGranted: query.data.groups.some(({ name }) => name === 'Global Checklist Editor'),
        query,
    };
}
